import { useStore } from 'effector-react';
import { $currentOrganization } from './store';
import { CurrentOrganization } from './types';

export const useCurrentOrganization: () => {
  organization: CurrentOrganization;
} = () => {
  const organization = useStore($currentOrganization);
  if (!organization) {
    throw new Error('Organization not init');
  }

  return { organization };
};

/** True when the org explicitly enables patient chart (server defaults false). */
export function usePatientChartEnabled(): boolean {
  const { organization } = useCurrentOrganization();
  return organization.settings_patient_chart_enabled === true;
}
